var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"powerText"},[_c('section',{staticClass:"row m-0"},[_vm._m(0),_c('div',{staticClass:"right entext col-lg-8"},[_c('img',{attrs:{"src":_vm.$t('homepage.sztext'),"alt":""}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left entext col-lg-4"},[_c('img',{attrs:{"src":require("@/assets/images/icon1.gif"),"alt":""}})])
}]

export { render, staticRenderFns }